// extracted by mini-css-extract-plugin
module.exports = {"root":"ToastBody_root__NbrcU","button":"ToastBody_button__TpbvI","useFade-fadeIn":"ToastBody_useFade-fadeIn__RR5pR","useFade-fadeOut":"ToastBody_useFade-fadeOut__8hvSa"};